import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_441_10927)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 1.39683V14.6032C4 15.3746 4.61561 16 5.375 16H14.625C15.3844 16 16 15.3746 16 14.6032V3.67563C16 3.30251 15.8531 2.9449 15.5919 2.68251L13.3239 0.403706C13.0665 0.145065 12.7191 0 12.357 0H5.375C4.61561 0 4 0.62538 4 1.39683ZM4.875 14.6032V1.39683C4.875 1.1163 5.09886 0.888889 5.375 0.888889H12.1875V3.93651C12.1875 4.46249 12.6072 4.88889 13.125 4.88889H15.125V14.6032C15.125 14.8837 14.9011 15.1111 14.625 15.1111H5.375C5.09886 15.1111 4.875 14.8837 4.875 14.6032ZM15.125 4V3.67563C15.125 3.53995 15.0716 3.40991 14.9766 3.3145L13.0625 1.39127V3.93651C13.0625 3.97157 13.0905 4 13.125 4H15.125Z",
				fill: "#9D9C9B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 12C12 12 13 11 13 9H11V7H10V9V12Z",
				fill: "#E48762"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 8V6C12.75 6 14 7.25 14 8H12Z",
				fill: "#F9D4C4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4.625C0 4.21079 0.335786 3.875 0.75 3.875H8.25C8.66421 3.875 9 4.21079 9 4.625V12.125C9 12.5392 8.66421 12.875 8.25 12.875H0.75C0.335786 12.875 0 12.5392 0 12.125V4.625Z",
				fill: "#C25B33"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3 10.7607V5.75H4.33301C4.82975 5.75 5.15446 5.77393 5.30713 5.82178C5.55094 5.89925 5.75146 6.06445 5.90869 6.31738C6.0682 6.57031 6.14795 6.89616 6.14795 7.29492C6.14795 7.65723 6.07959 7.96143 5.94287 8.20752C5.80615 8.45133 5.63525 8.62337 5.43018 8.72363C5.2251 8.82161 4.87191 8.87061 4.37061 8.87061H3.82715V10.7607H3ZM3.82715 6.59766V8.01953H4.28516C4.59277 8.01953 4.80127 7.99788 4.91064 7.95459C5.0223 7.9113 5.11344 7.83382 5.18408 7.72217C5.25472 7.60824 5.29004 7.46924 5.29004 7.30518C5.29004 7.13883 5.25358 6.9987 5.18066 6.88477C5.10775 6.77083 5.01774 6.6945 4.91064 6.65576C4.80355 6.61702 4.57682 6.59766 4.23047 6.59766H3.82715Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_441_10927",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgPpt;
